import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { Logo, WhatsAppIcon, buildWhatsAppLink } from "./Header";
import { resolveImageUrl } from "../../lib/api";

export function ReviewsPlaceholder() {
  return null; // substituído pela seção real de avaliações (ReviewsSection)
}

export default function Footer({ storeName, whatsappNumber, logoUrl, hours, instagram }) {
  const logoSrc = logoUrl ? resolveImageUrl(logoUrl) : "/logo.png";
  return (
    <footer className="border-t border-[#E8E2D9] py-12 px-6 bg-[var(--site-bg)] text-[#5A534C]">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6 text-xs">
        <div className="flex flex-col items-center md:items-start gap-2">
          <img src={logoSrc} alt={storeName} className="h-9 w-auto" />
          {hours && <p className="font-mono text-[11px]" data-testid="footer-hours">{hours}</p>}
        </div>
        <p className="font-mono text-[11px] text-center">
          Assistência técnica • Celulares & Acessórios • Entregas para todo o Brasil
        </p>
        <div className="flex gap-4 items-center">
          <a href="#catalogo" data-testid="footer-catalogo-link" className="hover:text-[#1A1816] transition-colors">
            Catálogo
          </a>
          <a
            href={buildWhatsAppLink(whatsappNumber, "Olá! Vim pelo catálogo online.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="inline-flex items-center gap-1 hover:text-[#1A1816] transition-colors"
          >
            <WhatsAppIcon className="w-3.5 h-3.5" />
            WhatsApp
          </a>
          {instagram && (
            <a href={instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="inline-flex items-center gap-1 hover:text-[#1A1816] transition-colors" aria-label="Instagram">
              <Instagram className="w-3.5 h-3.5" />
            </a>
          )}
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#1A1816] transition-colors">
            Área do Lojista
          </Link>
        </div>
      </div>
    </footer>
  );
}
